import { ConfigProvider, Spin } from 'antd';
import React from 'react';
import { createRoot, Root } from 'react-dom/client';
import getAntdConfigProps from 'src/vendor/antd/antd-config';

let reactRoot: Root | undefined = undefined;

export async function showPageMask(text?: string) {
  let container = document.querySelector('body div[data-page-mask=true]');
  if (!container) {
    container = document.createElement('div');
    container.setAttribute('data-page-mask', 'true');
    document.body.appendChild(container);
  }
  if (!reactRoot) {
    reactRoot = createRoot(container);
  }
  reactRoot.render(
    <ConfigProvider {...await getAntdConfigProps()}>
      <Spin spinning fullscreen tip={text || UiText.t('Shared_Loading_Text')} />
    </ConfigProvider>,
  );
}

export function hidePageMask() {
  const container = document.querySelector('body div[data-page-mask=true]');
  if (!container) {
    console.warn(`Trying to hide page mask when none is present`);
    return;
  }
  reactRoot?.unmount();
  container.remove();
  reactRoot = undefined;
}

export async function maskPage<T>(promise: PromiseLike<T>, text?: string): Promise<T> {
  await showPageMask(text);
  try {
    return await promise;
  } finally {
    hidePageMask();
  }
}
